import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';

@Component({
    selector: 'ig-page-spinner',
    templateUrl: './page.spinner.component.html',
    styleUrls: ['./page.spinner.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PageSpinnerComponent {
    public isLoading = false;
    @Input() public loadingTip: string;
    @Input() public diameter = 32;
    @Input() public strokeWidth = 3;

    constructor() {
        bindFunctionsToThis(this);
    }

    public show() {
        setTimeout(() => {
            this.isLoading = true;
        });
    }

    public hide() {
        this.isLoading = false;
    }

    public setLoadingTip(tip: string) {
        this.loadingTip = tip;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/page.spinner/page.spinner.component.ts